module.exports = __webpack_public_path__ + "static/TiemposHeadlineWeb-Semibold-679eb548d3b2e4319d85f560f78e02a9.woff2";